import { ConnectedPosition } from '@angular/cdk/overlay';

export const applicationTileMenuOverlayPositions: ConnectedPosition[] = [
    {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
    },
    {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom'
    }
];
